import { useTranslation } from 'react-i18next';
import AreaDropdown from '../../shared/dropdowns/AreaDropdown.js';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import DateInput from '../../shared/inputs/DateInput.js';

const AddTemperatureForm = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <input type="number" name="temperature"
             placeholder={t('temperature_placeholder')} required/>
      <AreaDropdown/>
      <DateInput name="date" required />
    </>
  );
}

const getBodyFromForm = (formData) => {
  const temperature = Number(formData.get("temperature"));
  const area  = formData.get("area");
  const date  = formData.get("date");
  return JSON.stringify({temperature, area, date})
}

export const AddTemperature = (props) => {
  return (
    <DataCollectionAdd
      collection="temperatures"
      getBodyFromForm={getBodyFromForm}
      formElements={AddTemperatureForm}
      onSuccess={props.onSuccess}
    />
  );
}

export default AddTemperature;
